import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {Filter} from '../models/filter.model';

@Injectable({ providedIn: 'root' })
export class FilteroffersService{

  private subject = new Subject<any>();

  setSelectedFilter(filter: Filter) {
    this.subject.next({idCard: filter.idCard, keyWord: filter.keyWord, categoryId: filter.categoryId, stateId: filter.stateId});
  }


  getSelectedFilter(): Observable<any>{
    return this.subject.asObservable();
  }

}
